import styled from 'styled-components';

export const FormWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  > div {
    min-height: auto;
    > div {
      min-height: auto;
      > div {
        > div {
          > div {
            height: 44px;
            margin-bottom: 17px;
          }
        }
      }
    }
  }

  legend {
    display: none;
  }
  .AAA {
    position: relative;
  }
`;

export const DescriptionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
`;

export const LabelWithIcon = styled.label`
  font-size: 13px;
  color: #000000;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 2px;
`;

export const InfoIcon = styled.img``;

export const SwitchWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
  font-size: 14px;
  color: #000000;
`;

export const ButtonWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 12px;

  button {
    width: 100%;
    border-radius: 8px;
    border: 1px solid #0000001a;
    color: #0a0a0a;
    font-size: 14px;
    font-weight: 500;
  }

  button:last-child {
    background: linear-gradient(90deg, #2a75e8 0%, #1f406e 100%);
    color: #ffffff;
    border: none;
  }
`;

export const ErrorForInputs = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 4px;
  margin-top: -11px;
  width: 100%;
`;
export const AlertIcon = styled.img``;
export const ErrorMessage = styled.p`
  color: #e63946;
  font-weight: 600;
  font-size: 12px;
  margin: 0;
  line-height: 1;
`;
